exports.f = require('./_wks');



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_wks-ext.js
 ** module id = 55
 ** module chunks = 2 4 5 7
 **/